// Shared localStorage key for the app-wall session token (AuthProvider owns
// the value; LicenseProvider and admin fetch helpers only read it).
// Exported as a small module so the key string exists in ONE place.

export const SESSION_TOKEN_KEY = 'colorsep_session_token';

export function getStoredSessionToken(): string | null {
  try {
    return localStorage.getItem(SESSION_TOKEN_KEY);
  } catch {
    return null;
  }
}

/** Fired by AuthProvider after login/logout so LicenseProvider can refresh. */
export const AUTH_CHANGED_EVENT = 'colorsep:auth-changed';
